module.exports = __webpack_public_path__ + "img/Aleyna.65dff194.jpg";